/** @file Emits a solid quad (four pixel corners in order) on the white page. */
import type { Sink } from './createSink';
import { emitMesh, type PixelMesh } from './emitMesh';

const QUAD = [0, 1, 2, 0, 2, 3];
/** The primitive, refilled per call (no object per quad). */
const mesh: PixelMesh = { page: 0, count: 4, xy: QUAD, uv: null, light: 0, lights: null, indices: QUAD };

/** `xy` = 8 numbers: corners in winding order (either winding renders). */
export function emitQuad(sink: Sink, xy: ArrayLike<number>, light: number): void {
  mesh.page = sink.white;
  mesh.xy = xy;
  mesh.light = light;
  emitMesh(sink, mesh);
}
